import { getStorageItem, removeStorageItem, setStorageItem, type StorageKey } from '@/lib/pwa-storage'

/**
 * Valor JSON en localStorage que sobrevive al round-trip same-origin del OAuth
 * web (la página se recarga al volver). Se apoya en `lib/pwa-storage`, que ya
 * pone el guard de SSR y el try/catch; aquí solo se añade el JSON y el parser.
 * Nunca lanza.
 *
 * `parse` recibe lo que haya guardado — que puede estar manipulado — y devuelve
 * null si no lo reconoce.
 */
export interface LocalStorageCarrier<T> {
  read(): T | null
  write(value: T): void
  clear(): void
}

export function createLocalStorageCarrier<T>(
  key: StorageKey,
  parse: (stored: unknown) => T | null
): LocalStorageCarrier<T> {
  return {
    read() {
      const raw = getStorageItem(key)
      if (raw === null) return null

      try {
        return parse(JSON.parse(raw))
      } catch {
        return null
      }
    },
    write(value) {
      setStorageItem(key, JSON.stringify(value))
    },
    clear() {
      removeStorageItem(key)
    }
  }
}
